import api from '../components/Axios/axios';
let pendingLogout;
export const logoutSession = () => {
  if (!pendingLogout) {
    pendingLogout = (async () => {
      try {
        if (localStorage.getItem('token')) await api.post('/Audit/session/logout', {}, { timeout: 2000 });
      } catch {
        // A disconnected device must still be able to sign out locally.
      } finally {
        localStorage.removeItem('token');
        api.clearGetCache();
      }
    })().finally(() => { pendingLogout = null; });
  }
  return pendingLogout;
};
